import classNames from 'classnames'
import React, { useContext, useEffect } from 'react'

import { LocaleContext } from '../locale/i18n'
import { Product } from '../logic/catalog'
import { gaEvents } from '../logic/ga4'

import MiniProductPreview from './MiniProductPreview'

import './ProductGrid.scss'

const ProductGrid = ({
  pageName,
  products,
  showVat = true,
}: {
  pageName: string
  products: Product[]
  showVat?: boolean
}) => {
  const { t } = useContext(LocaleContext)

  useEffect(() => {
    gaEvents.productsShown(pageName, products)
  }, [])

  return (
    <div className="productGrid">
      <div
        className={classNames('productGrid__grid', {
          'productGrid__grid--many': products.length > 2,
        })}
      >
        {products.map(p => (
          <MiniProductPreview key={p.id} {...p} />
        ))}
      </div>
      {showVat && products.some(p => p.fixedPrice !== null) && (
        <p className="productGrid__smallPrint">{t('pricing.noVatLong')}</p>
      )}
    </div>
  )
}

export default ProductGrid
